$(document).ready(function () {
  $(".expandable-container").hide();
  $(".js-expand").click(function () {
    var el = $(this);
    toggleNutrition(el);
  });
});

$(document).on("lity:close", function () {
  $(".js-expand.expanded").removeClass("expanded");
  $(".expandable-container").hide();
});

function toggleNutrition(el) {
  if ($(el).hasClass("expanded")) {
    $(el).removeClass("expanded");
    $(el).next().slideUp(200);
  } else {
    $(".js-expand.expanded").removeClass("expanded");
    $(".expandable-container").slideUp(200);
    $(el).addClass("expanded");
    $(el).next().slideDown(200, function () {
      this.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    });
  }
}
